"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _shoppingToolsCard = require("@mmc/shopping-tools-card");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var _promotionLink = _interopRequireDefault(require("./promotion-link"));
var _subNavLinks = _interopRequireDefault(require("./sub-nav-links"));
var _menuPanelSubColumn = require("./menu-panel-sub-column");
var _productAccordion = _interopRequireDefault(require("./product-accordion"));
var _span;
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  formatAsMKSPath = dataUtils.formatAsMKSPath;
var getListClasses = function getListClasses(params) {
  var menuOpen = params.menuOpen,
    theme = params.theme,
    isLast = params.isLast,
    isSelected = params.isSelected;
  return _navigationHeader["default"].navBtnItem + " " + (menuOpen ? null : theme.grey) + " " + _navigationHeader["default"].subColumnWrap + " " + (!isSelected ? _navigationHeader["default"].hideoffCanvasMenu : '') + " " + (isLast ? _navigationHeader["default"].lastBtnItem : '') + " menu-panel-top-level-item";
};
var MenuPanelMobileOffCanvas = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(MenuPanelMobileOffCanvas, _React$Component);
  function MenuPanelMobileOffCanvas(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var keyHandler = props.keyHandler || _this.keyHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusHandler = _this.focusHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.refList = {};
    _this.state = {
      keyHandler: keyHandler
    };
    _this.handleMouseDownToggle = _this.handleMouseDownToggle.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = MenuPanelMobileOffCanvas.prototype;
  _proto.handleMouseDownToggle = function handleMouseDownToggle() {
    var _this$props = this.props,
      currentPath = _this$props.currentPath,
      products = _this$props.products,
      _this$props$config = _this$props.config,
      market = _this$props$config.market,
      currencyFormat = _this$props$config.currencyFormat,
      name = _this$props.name;
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navclick',
        component: 'top_nav',
        action: "mobile_back",
        click_text: 'back'
      });
    }
    if (market.toLowerCase() === 'mx' && typeof window !== 'undefined' && window.dataLayer && products && products.length > 0) {
      var productsClone = [];
      products.forEach(function (product) {
        productsClone.push((0, _menuPanelSubColumn.prepareProductForDataLayer)(product, currencyFormat));
      });
      window.dataLayer.push({
        event: 'view_item_list',
        view_item_listdata: [{
          position: 'Header',
          items: productsClone.map(function (product) {
            return (0, _menuPanelSubColumn.prepareProductForDataLayer)(product, currencyFormat);
          }),
          item_list_name: name,
          layer: formatAsMKSPath(currentPath)
        }]
      });
    }
  };
  _proto.keyHandler = function keyHandler() {
    var keyHandlerMethod = this.props.keyHandlerMethod;
    keyHandlerMethod.apply(void 0, arguments);
  };
  _proto.focusHandler = function focusHandler() {
    var focusHandler = this.props.focusHandler;
    if (focusHandler !== undefined) {
      focusHandler(true);
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      name = _this$props2.name,
      keyHandler = _this$props2.keyHandler,
      clickHandler = _this$props2.clickHandler,
      activeNav = _this$props2.activeNav,
      subNavigationcontainer = _this$props2.subNavigationcontainer,
      shoppingToolsCTAs = _this$props2.shoppingToolsCTAs,
      addPriceDisclaimer = _this$props2.addPriceDisclaimer,
      priceDisclaimerId = _this$props2.priceDisclaimerId,
      disclaimerData = _this$props2.disclaimerData,
      menuOpen = _this$props2.menuOpen,
      theme = _this$props2.theme,
      links = _this$props2.links,
      products = _this$props2.products,
      displayNavInTwoColumns = _this$props2.displayNavInTwoColumns,
      market = _this$props2.market,
      config = _this$props2.config,
      currentPath = _this$props2.currentPath,
      keyHandlerMethod = _this$props2.keyHandlerMethod,
      isSelected = _this$props2.isSelected,
      mobileNavActive = _this$props2.mobileNavActive,
      imageWithText = _this$props2.imageWithText,
      hideArrows = _this$props2.hideArrows; // eslint-disable-line
    var subNavigationItems = subNavigationcontainer.subNavigationItems,
      promoterDetails = subNavigationcontainer.promoterDetails;
    var shoppingToolsData = {
      label: '',
      ctas: shoppingToolsCTAs,
      sectionId: null,
      sectionTitle: null,
      __typename: 'ShoppingToolsCards'
    };
    var id = name.toLowerCase();
    var linkSetSize = (0, _menuPanelSubColumn.getLength)(links) ? links.length : 0;
    var productSetSize = (0, _menuPanelSubColumn.getLength)(products) ? products.length : 0;
    var totalSetSize = linkSetSize + productSetSize;
    var hasPopUp = !!(linkSetSize || productSetSize);
    var reducedHeight = !(links.length > 0 && products.length === 0);
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: getListClasses({
        menuOpen: menuOpen,
        theme: theme,
        isSelected: isSelected
      }),
      role: "menuitem",
      "aria-expanded": true,
      "aria-haspopup": hasPopUp,
      "data-menu-item-name": name
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _navigationHeader["default"].navBtn + " " + theme.lowIcon + " " + theme.mmcIconChevronRight + " " + _navigationHeader["default"].backBtn,
      onKeyDown: keyHandler,
      onFocus: this.focusHandler,
      onClick: clickHandler,
      onMouseDown: this.handleMouseDownToggle,
      type: "button"
    }, _span || (_span = /*#__PURE__*/_react["default"].createElement("span", null, "Back"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].navPanel + " " + (_navigationHeader["default"][id] ? _navigationHeader["default"][id] : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _navigationHeader["default"].innerLinkContainer + " " + (displayNavInTwoColumns === true ? _navigationHeader["default"].displayNavInTwoColumns : '')
    }, !isEmptyArray(products) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "" + _navigationHeader["default"].subNavHeading
    }, name), /*#__PURE__*/_react["default"].createElement(_productAccordion["default"], {
      products: products,
      theme: theme,
      totalSetSize: totalSetSize,
      name: name,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData,
      market: market,
      config: config,
      currentPath: currentPath,
      keyHandlerMethod: keyHandlerMethod,
      mobileNavActive: mobileNavActive,
      hideArrows: hideArrows
    }), /*#__PURE__*/_react["default"].createElement(_promotionLink["default"], {
      imageWithText: imageWithText,
      theme: theme,
      layoutType: "vertical",
      mobileNavActive: mobileNavActive,
      disclaimerData: disclaimerData,
      name: name
    })), !isEmptyArray(subNavigationItems) && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _navigationHeader["default"].navPromoWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + _navigationHeader["default"].subNavigationContainer
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _navigationHeader["default"].subNavHeading + " " + _navigationHeader["default"].noBottomSpacing
    }, name), !isEmptyArray(shoppingToolsCTAs) && /*#__PURE__*/_react["default"].createElement(_shoppingToolsCard.ShoppingToolsCard, {
      theme: theme,
      data: shoppingToolsData,
      className: _navigationHeader["default"].shoppingToolWrapper,
      componentContainer: "top_nav"
    }), /*#__PURE__*/_react["default"].createElement(_subNavLinks["default"], {
      reducedHeight: reducedHeight,
      totalSetSize: totalSetSize,
      name: name,
      displayNavInTwoColumns: displayNavInTwoColumns,
      market: market,
      theme: theme,
      subNavigationItems: subNavigationItems,
      keyHandlerMethod: keyHandlerMethod,
      mobileNavActive: mobileNavActive
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-xs-12']
    }, /*#__PURE__*/_react["default"].createElement(_promotionLink["default"], (0, _extends2["default"])({}, promoterDetails, {
      theme: theme,
      layoutType: "vertical",
      imageWithText: imageWithText,
      mobileNavActive: mobileNavActive,
      name: name
    })))))));
  };
  return MenuPanelMobileOffCanvas;
}(_react["default"].Component);
MenuPanelMobileOffCanvas.displayName = 'MenuPanelMobileOffCanvas';
MenuPanelMobileOffCanvas.defaultProps = {
  links: [],
  products: []
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(MenuPanelMobileOffCanvas);
exports["default"] = _default;